import type {
  DiagnosticFinding,
  DiagnosticMatrix,
  DiagnosticSeverity,
} from "./types";

function count(
  findings: readonly DiagnosticFinding[],
  severity: DiagnosticSeverity,
): number {
  return findings.filter((finding) => finding.severity === severity).length;
}

export function buildDiagnosticMatrix(
  findings: readonly DiagnosticFinding[],
): DiagnosticMatrix {
  return {
    findings: [...findings],
    totalFindings: findings.length,
    criticalCount: count(findings, "critical"),
    highCount: count(findings, "high"),
    mediumCount: count(findings, "medium"),
    lowCount: count(findings, "low"),
    infoCount: count(findings, "info"),
  };
}
